import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CaseImage, IncidentFormControls } from '../../../../../types';

@Component({
  selector: 'app-review-form-suspicious-incident-report-options',
  templateUrl: './review-form-suspicious-incident-report-options.component.html',
  styleUrl: './review-form-suspicious-incident-report-options.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormSuspiciousIncidentReportOptionsComponent {
  public form = input.required<FormGroup<IncidentFormControls>>();
  public isLoadingCaseImages = input<boolean>(false);
  public caseImages = input<CaseImage[]>([]);

  createNewCase() {
    this.form().controls.matchingCase.markAsDirty();
    this.form().controls.matchingCase.setValue('new_case');
  }
}
